import {styled} from '../../utils';
import {clearFix} from 'polished';

export default styled('div')(clearFix());



// WEBPACK FOOTER //
// ./src/components/Clearfix/Clearfix.tsx